import { Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { unauthenticatedGuard } from '@shared/guards/unauthenticated.guard';
import { CustomCallbackComponent } from '@shared/components/organisms/custom-callback/custom-callback.component';
import { adminMenuGuard } from '@shared/guards/admin-menu.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then((r) => r.HOME_ROUTES),
      },

      //ADMIN FEATURES
      {
        path: 'admin',
        canActivate: [adminMenuGuard],
        canActivateChild: [adminMenuGuard],
        loadChildren: () =>
          import('./features/admin/admin.routes').then(r => r.ADMIN_ROUTES),
      },


      //NON-ADMIN FEATURES (to be created)
      {
        path: 'proposals',
        loadChildren: () =>
          import('./features/proposals/proposals.routes').then(r => r.PROPOSALS_ROUTES),
      },
      {
        path: 'dockets',
        loadChildren: () =>
          import('./features/dockets/dockets.routes').then(r => r.DOCKETS_ROUTES),
      },
      {
        path: 'disposition-bulletin',
        loadChildren: () =>
          import('./features/disposition-bulletin/disposition-bulletin.routes').then(r => r.DISPOSITION_BULLETIN_ROUTES),
      },
      {
        path: 'supplement',
        loadChildren: () =>
          import('./features/supplement/supplement.routes').then(r => r.SUPPLEMENT_ROUTES),
      },
      {
        path: 'book',
        loadChildren: () =>
          import('./features/book/book.routes').then(r => r.BOOK_ROUTES),
      },
      {
        path: 'data-files',
        loadChildren: () =>
          import('./features/data-files/data-files.routes').then(r => r.DATA_FILES_ROUTES),
      },
      {
        path: 'density-sheet',
        loadChildren: () =>
          import('./features/density-sheet/density-sheet.routes').then(r => r.DENSITY_SHEET_ROUTES),
      },
    ]
  },
  { path: 'login/callback', component: CustomCallbackComponent },
  {
    path: 'welcome',
    canActivate: [unauthenticatedGuard],
    loadComponent: () => import('./features/welcome/welcome.component').then((m) => m.WelcomeComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
